<template>
  <div>
    <v-card class="mx-auto">
      <v-toolbar color="secondary" dark height="45">
        <v-toolbar-title class="d-flex justify-space-between align-center text-body-1" style="width: 100%">
          <div>
            <v-icon left class="mr-2" size="20">mdi-cogs</v-icon>
            {{ $t('PANEL.OPTION.NAVIGATION_TITLE') }}
          </div>
          <div>
            <slot name="append-inner"></slot>
          </div>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-card>
    <v-card class="mx-auto">
      <v-navigation-drawer width="100%" permanent>
        <v-list>
          <v-list-item
            :key="key"
            v-for="(setting, key) in settingsNavigation"
            link
            :class="[
              route.path === '/settings/system-settings' &&
              setting.sysname === 'genel'
                ? 'v-list-item--active'
                : ''
            ]"
            :to="`/settings/system-settings/setting/${setting.sysname}`"
          >
            <v-list-item-icon class="my-3 mr-4">
              <v-icon>mdi-cog-transfer</v-icon>
            </v-list-item-icon>

            <v-list-item-content class="py-0">
              <v-list-item-title class="text-body-2">{{
                setting.name
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>
    </v-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LanguageSelector from "@/components/Base/LanguageSelector.vue";
export default {
  name: "OptionNavigation",
  components: { LanguageSelector },
  computed: {
    ...mapState({
      settingsNavigation: state => state.Option.ApiOptions.optionList,
      inputList: state => state.Option.ApiOptions.inputList,
      apiLanguage: (state) => state.Language.apiLanguage
    }),
    /**
     * @returns {Object}
     */
    route() {
      return this.$route;
    }
  },
  created() {
    this.$store.dispatch("Option/ApiOptions/getOptionList");
  }
};
</script>